export const REGISTRATION_DETAILS = {
    ageInYears: {
        age_0: '{{count}} год',
        age_1: '{{count}} года',
        age_2: '{{count}} лет',
        lessYear: '<1 года',
    },
}
